import React from "react";
import { motion } from "framer-motion";
import ResumeCard from "./ResumeCard";

const Achievement = () => {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1, transition: { duration: 0.5 } }}
      className="py-12 font-titleFont flex gap-20"
    >
      <div>
        <div className="py-12 font-titleFont flex flex-col gap-4">
          <p className="text-sm text-designColor tracking-[4px]"></p>
          <h2 className="text-4xl font-bold">Company Experience</h2>
        </div>
        <div className="mt-14 w-full h-[1000px] border-l-[6px] border-l-black border-opacity-30 flex flex-col gap-10">
          <ResumeCard
            title="WEB DEVELOPER - MENTAPPS SOLUTIONS."
            subTitle="Ikeja."
            result="Success"
            des="Responsible for creating all aspects of clients website, from start to finish"
          />
          <ResumeCard
            title="WEB DEVELOPER-LISONET."
            subTitle="Ikeja."
            result="Success"
            des="Ensure website functionality and stability across devices. Design engaging landing pages. Manage and Maintain the company's website."
          />
          <ResumeCard
            title="FRONT END DEVELOPER-OPERA ADS."
            subTitle="Opebi."
            result="Success"
            des="Lead web designer at Opera ADS"
          />
        </div>
      </div>
      <div>
        <div className="py-12 font-titleFont flex flex-col gap-4">
          <p className="text-sm text-designColor tracking-[4px]"></p>
          <h2 className="text-4xl font-bold">Job Experience</h2>
        </div>
        <div className="mt-14 w-full h-[1000px] border-l-[6px] border-l-black border-opacity-30 flex flex-col gap-10">
          <ResumeCard
            title="WEB DEVELOPER - MENTAPPS SOLUTIONS."
            subTitle="Ikeja."
            result="Success"
            des="Responsible for creating all aspects of clients website, from start to finish!"
          />
          <ResumeCard
            title="FRONT END DEVELOPER-OPERA ADS."
            subTitle="Opebi."
            result="Success"
            des="Lead web designer at Opera ADS"
          />
          <ResumeCard
            title="WEB DEVELOPER-LISONET."
            subTitle="Ikeja"
            result="Success"
            des="Ensure website functionality and stability across devices. Design engaging landing pages. Manage and Maintain the company's website."
          />
        </div>
      </div>
    </motion.div>
  );
};

export default Achievement;
